import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import DocumentationSidebar from '../component/DocumentationSidebar';
import SettingsMenuOverview from './SettingsMenuOverview';
import { DocContentImage, DocSidebarImage } from '../component/DocMedia';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';
import {
  getOrganizationPolicyKey,
  ORGANIZATION_POLICY_DOCS,
} from './organizationPolicyConfig';

function OrganizationPolicyDoc({ policyKey }) {
  const { t } = useTranslation();
  const meta = ORGANIZATION_POLICY_DOCS[policyKey];
  const baseKey = `documentation.organizationDetails.${policyKey}`;

  const image001 = useDocImage(meta.imageFolder, 'image001.png', 'settings');
  const image002 = useDocImage(meta.imageFolder, 'image002.png', 'settings');

  return (
    <>
      <h1 className="mt-0 text-primary">{t(`${baseKey}.title`)}</h1>
      <p className="header-para">{t(`${baseKey}.intro`)}</p>

      <div className="card dashboard-card mb-4">
        <div className="card-header px-3">{t(`${baseKey}.accessing.title`)}</div>
        <div className="card-body">
          <SettingsMenuOverview />
          <ul>
            <li dangerouslySetInnerHTML={{ __html: t(`${baseKey}.accessing.steps.step1`) }} />
            <li dangerouslySetInnerHTML={{ __html: t(`${baseKey}.accessing.steps.step2`) }} />
          </ul>
          <DocSidebarImage src={image001} alt={t(`${baseKey}.accessing.imageAlt`)} />
          <ul className="mb-0">
            <li dangerouslySetInnerHTML={{ __html: t(`${baseKey}.accessing.steps.step3`) }} />
          </ul>
        </div>
      </div>

      <div className="card dashboard-card mb-4">
        <div className="card-header px-3">{t(`${baseKey}.editor.title`)}</div>
        <div className="card-body">
          <DocContentImage src={image002} alt={t(`${baseKey}.editor.imageAlt`)} />
          <ul>
            <li>{t(`${baseKey}.editor.items.toolbar`)}</li>
            <li>{t(`${baseKey}.editor.items.content`)}</li>
            <li>{t(`${baseKey}.editor.items.save`)}</li>
          </ul>
        </div>
      </div>

      <p className="alert alert-info mb-0">{t(`${baseKey}.permissionsNote`)}</p>
    </>
  );
}

export default function OrganizationDetails() {
  const { pathname } = useLocation();

  if (pathname.endsWith('/document-organization-details')) {
    return (
      <Navigate
        to="/admin/ducumentation/settings/document-organization-details/privacy-policy"
        replace
      />
    );
  }

  const policyKey = getOrganizationPolicyKey(pathname);

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <OrganizationPolicyDoc policyKey={policyKey} />
          </div>
        </div>
      </div>
    </div>
  );
}
